jQuery(function ($) {
  setTimeout(function () {
    $(".page-header-luxy").addClass("active");
  }, 1000);

  setTimeout(function () {
    $(".section-fv-luxy .title-section").addClass("active");
  }, 1800);

  setTimeout(function () {
    $(".section-fv .video").addClass("active");
  }, 1000);

  setTimeout(function () {
    $(".top-container").addClass("active");
  }, 1800);
});

jQuery(function ($) {
  const $bannerCampaign = $('.banner-campaign')
  const $footer = $('footer')

  $('.banner-campaign__close').on('click', function() {
    $('.banner-campaign').fadeOut(function() {
      $(this).remove()
    })
  });

  $(window).on('load scroll', function() {
    let footerOffset = $footer.offset().top

    if(footerOffset <= window.innerHeight + window.scrollY) {
      $bannerCampaign.fadeOut()
    }else {
      $bannerCampaign.fadeIn()
    }
  })
});
